import React from "react";
import { StyleSheet, View, Text, Image, TouchableOpacity } from "react-native";

import { MaterialIcons, Entypo } from "@expo/vector-icons";

const ModalSell = ({ handleCloseModal }) => {
    return (
        <>
            <View style={styles.headerLeft}>
                <MaterialIcons
                    onPress={handleCloseModal}
                    name="close"
                    size={30}
                    color="black"
                />

                {/* <Entypo
                    name="share"
                    size={30}
                    color="black"
                /> */}
            </View>

            <View style={styles.container}>
                <Image
                    source={require("../../assets/success.png")}
                    style={styles.image2}
                />
                <Text style={styles.text}>
                    Sua ordem de venda foi criada com{" "}
                    <Text style={styles.success}>sucesso!</Text>
                </Text>

                {/* <TouchableOpacity>
                    <Text
                        style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: 12,
                            marginTop: 100,
                            textDecorationLine: 'underline',
                            color: "#228c9a",
                            fontSize: 14
                        }}
                    >
                        VER COMPROVANTE
                    </Text>
                </TouchableOpacity> */}
            </View>

            <Image
                source={require("../../assets/imgs/gpxcoinModal.png")}
                style={styles.cardCoin}
            />
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        padding: 75,
        marginTop: 35,
    },
    headerLeft: {
        marginTop: 25,
        padding: 15,
        // alignItems: "flex-start",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    headerRight: {
        marginTop: 25,
        padding: 15,
        alignItems: "flex-end",
    },
    image1: { width: "35%", height: "47%", resizeMode: "stretch" },
    image2: { width: 90, height: 90 },
    text: {
        fontSize: 18,
        marginTop: 30,
        textAlign: "center",
    },
    success: {
        fontWeight: "bold",
        color: "#1FBFB5",
    },
    cardCoin: {
        flex: 1,
        width: 300,
        height: 300,
        position: "absolute",
        right: -50,
        bottom: -50,
    },
});


export default ModalSell;
